import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  ApiClient,
  AppointmentDispositionItemInfo,
  CreateAppointmentDispositionUpdateSubmissionDto,
  PendingSaleAppointmentDispositionInfo,
  ServiceDispositionItemInfo,
  UpdateServiceAppointmentDispositionSubmissionDto,
} from '../sdk/sdk';

@Injectable({
  providedIn: 'root',
})
export class DispositionService {
  private readonly sdk: ApiClient = inject(ApiClient);

  getAppointmentDispositions(): Observable<AppointmentDispositionItemInfo[]> {
    return this.sdk.getAppointmentDispositionsWeb();
  }

  getServiceAppointmentDispositions(): Observable<ServiceDispositionItemInfo[]> {
    return this.sdk.getServiceDispositionsWeb();
  }

  updateAppointmentDisposition(
    request: CreateAppointmentDispositionUpdateSubmissionDto
  ): Observable<PendingSaleAppointmentDispositionInfo> {
    return this.sdk.createAppointmentDispositionUpdateSubmission(request);
  }

  updateServiceAppointmentDisposition(
    request: UpdateServiceAppointmentDispositionSubmissionDto
  ): Observable<UpdateServiceAppointmentDispositionSubmissionDto> {
    return this.sdk.updateServiceAppointmentDispositionSubmission(request);
  }
}
